interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showText?: boolean;
  className?: string;
}

const sizes = {
  sm: { icon: 'h-6 w-6', text: 'text-base', gap: 'gap-2' },
  md: { icon: 'h-8 w-8', text: 'text-lg', gap: 'gap-2' },
  lg: { icon: 'h-10 w-10', text: 'text-2xl', gap: 'gap-3' },
  xl: { icon: 'h-14 w-14', text: 'text-3xl', gap: 'gap-3' },
};

export function Logo({ size = 'md', showText = true, className = '' }: LogoProps) {
  const s = sizes[size];

  return (
    <div className={`my360-logo flex items-center ${s.gap} ${className}`}>
      <img
        src="/logo.png"
        alt="my360"
        className={`${s.icon} object-contain shrink-0`}
        draggable={false}
      />
      {showText && (
        // eslint-disable-next-line i18next/no-literal-string
        <span className={`${s.text} font-logo text-[var(--color-text)]`}>
          my360
        </span>
      )}
    </div>
  );
}

export function LogoIcon({ size = 'md', className = '' }: Omit<LogoProps, 'showText'>) {
  const s = sizes[size];

  return (
    <img
      src="/logo.png"
      alt="my360"
      className={`${s.icon} object-contain shrink-0 ${className}`}
      draggable={false}
    />
  );
}

export default Logo;
